import { Combobox } from '@deque/cauldron-react';
import React from 'react';
import {
  type Control,
  Controller,
  type FieldPath,
  type FieldValues
} from 'react-hook-form';

export interface ComboboxOptionType {
  key: string;
  label: string;
  value: string;
}

export interface Props<T extends FieldValues> {
  label: string;
  name: FieldPath<T>;
  id: string;
  disabled: boolean;
  formControl: Control<T>;
  options: ComboboxOptionType[];
}

const MultiSelectSetting = <T extends FieldValues>({
  formControl,
  label,
  name,
  id,
  disabled,
  options
}: Props<T>) => {
  return (
    <Controller
      control={formControl}
      name={name}
      render={({ field: { ref, onChange, value, ...field } }) => {
        const normalizedValue = Array.isArray(value)
          ? value.map(
              (item: string) =>
                options.find(option => option.key === item)?.value ?? item
            )
          : [];

        return (
          <Combobox
            {...field}
            ref={ref}
            key={new Date().getTime()}
            id={id}
            label={label}
            multiselect
            value={normalizedValue}
            options={options}
            onSelectionChange={({ value: selectedItems }) =>
              onChange(
                selectedItems.map(
                  item =>
                    /* istanbul ignore next */
                    options.find(option => option.value === item)?.key ?? item
                )
              )
            }
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default MultiSelectSetting;
